export default __webpack_public_path__ + "static/media/Greige fabric.c06016ea.png";